module.exports = __webpack_public_path__ + "media/images/e-kvitok/bus_bg-bc9d4b40dd0db48745e5ec63b31dc03c.svg";